import { execute, GET, POST, DELETE, PATCH} from "."

const baseUrl = (route='')=> `api/portOuts${route}`

export const portOutsList = ({$store}, data)=> execute({method:GET, route: baseUrl(), $store, params: data})
export const updatePortOut = ({$store, modify})=> execute({method:PATCH, route: baseUrl(), $store, data:modify})
export const getDetailPorOut = ({$store, dn})=> execute({method:GET, route: baseUrl(`/${dn}`), $store})
export const updateActive = ({$store, data})=> execute({method:POST, route: baseUrl(`/activacion`), $store, data})
export const recharge = ({$store,id})=> execute({method:POST, route: baseUrl('/transactions'), $store, data:{ id}})
export const rechargeExternally = ({$store,id})=> execute({method:POST, route: baseUrl('/foreignTransactions'), $store, data:{ id}})
export const inventoryDays = ({$store, data})=> execute({method:POST, route: baseUrl('/inventoryDays'), $store, data:data})
export const inventoryDaysRoute = ({$store, data})=> execute({method:POST, route: baseUrl('/inventoryDaysRoute'), $store, data:data})

